import React from 'react'

const SellYourCarWidget = ({ title, text, callToActionText }) => (
  <div>
    <h1>{title}</h1>
    <p dangerouslySetInnerHTML={{ __html: text }} />
    {callToActionText && <p>{callToActionText}</p>}
  </div>
)

export default SellYourCarWidget
